<template>
  <div class="edit-box">
    <div class="input-box editor-box">
      <span class="edit-title">{{this.title}}</span>
      <input :placeholder="tips" v-model="editValue" class="input" />
    </div>
    <p v-if="msg" class="msg">{{msg}}</p>
  </div>
</template>

<script>
export default {
  props: ["title", "tips", "defaultValue", "options", "attr", "msg"],
  data() {
    return {
      editValue: this.defaultValue
    };
  },
  watch: {
    editValue(newValue) {
      this.$emit("updateValue", {
        value: newValue,
        attr: this.attr
      });
    }
  },

}
</script>

<style lang="scss" scoped>
.editor-box {
  display: -webkit-flex; /* Safari */
  display: flex;
  .edit-title {
    color: #fff;
    text-align: center;
    width: 11.3vh;
    height: 3.8vh;
    line-height: 3.8vh;
    background: #00a3ff;
    border-radius: 6px;
    font-size: 1.5vh;
    margin-right: .4vh;
  }
}
.edit-box {
  margin-bottom: .9vh;
  .input-box {
    .input {
      background: none;
      border: 1px solid #bcbcbc;
      border-radius: 6px;
      font-size: 1.5vh;
      padding: 0 .9vh;
      line-height: 3.8vh;
      flex-grow: 1;
      outline: none;
      &::-webkit-input-placeholder {
        color: #bcbcbc;
      }
    }
  }
  .msg {
    font-size: 12px;
    text-align: left;
    color: #999;
    margin: 5vh auto 0;
  }
}
</style>